import { Component, OnInit } from '@angular/core';
import { ErrorMatcher } from 'src/app/shared/error.matcher';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth.service';
import { LoaderService } from 'src/app/shared/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../../admin/service';
import { ActivityService } from '../../../shared/activity.service';

@Component({
	selector: 'app-registration-step',
	templateUrl: './registration-step.component.html',
	styleUrls: ['./registration-step.component.scss'],
	standalone: false
})
export class RegistrationStepComponent implements OnInit {
	loginFaild: string;
	showSuccessPopUp: boolean;

	matcher = new ErrorMatcher();
	registrationForm = new UntypedFormGroup({
		email: new UntypedFormControl('', [
			Validators.required,
			Validators.email,
		]),
		password: new UntypedFormControl('', [
			Validators.required,
			Validators.minLength(8)
		]),
		terms: new UntypedFormControl(false, [
			Validators.requiredTrue
		])
	});

	loaderStatus = false;
	redirectAffiliate = false;

	hide = true;

	get email() { return this.registrationForm.get('email'); }
	get password() { return this.registrationForm.get('password'); }
	get terms() { return this.registrationForm.get('terms'); }

	constructor(
		private router: Router,
		private auth: AuthService,
		private route: ActivatedRoute,
		private httpService: HttpService,
		private loaderService: LoaderService,
		private activityService: ActivityService,
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(async params => {
			if (params.invitation != undefined || params.invitation != null) {
				this.redirectAffiliate = true;
				sessionStorage.setItem("inviteId", params.invitation);

				if (sessionStorage.getItem('invited') != 'true') {
					await this.activityService.handleAffiliate({ invitation: params.invitation }).toPromise();

					sessionStorage.setItem("invited", 'true');

					window.open("https://quranera.com", "_self");
				} else {
					this.redirectAffiliate = false;
				}
			}
		});

		this.auth.logout();
	}

	async generateAffiliateId(data: any): Promise<any> {
		var result = await this.activityService.generateAID(data).toPromise();
		return result.ID;
	}

	async registration() {
		this.auth.logout();
		this.loginFaild = null;
		this.loaderService.loaderStatus.next(true);
		var referral = sessionStorage.getItem("inviteId");

		var affiliateId = await this.generateAffiliateId({ data: "data" });

		await this.auth.register(this.email.value, this.password.value).then(async (resultD) => {
			let currentDate = new Date().getTime();
			let value = {
				email: this.email.value.toLowerCase(),
				country: "",
				childs: [],
				regDate: currentDate,
				referralId: referral,
				affiliateInfo: { affiliateId: affiliateId ? affiliateId : 0, clicks: 0, registrations: 0, freeMonthsEarned: 0 }
			};

			await this.httpService.checkParentToken(async () => {
				this.auth.sendEmailVerification();
				this.auth.login(this.email.value, this.password.value).then(async (result: any) => {
					if (result.user) {
						let userStr = JSON.stringify(result.user);
						let userObj = JSON.parse(userStr);

						await this.activityService.createSelfData({ token: userObj.stsTokenManager.accessToken, parent: value }).toPromise();

						await this.auth.parentCreated().toPromise();

						sessionStorage.removeItem("inviteId");

						localStorage.setItem('currentUser', userStr);

						this.router.navigate(['/cabinet']);
					}
					this.loaderService.loaderStatus.next(false);
				});
			});
		}).catch(error => {
			this.loginFaild = error.message;
			this.loaderService.loaderStatus.next(false);
		});
	}

	async loginViaGoogle() {
		this.loaderStatus = true;
		var googleRes = await this.auth.googleSignin();

		var referral = sessionStorage.getItem("inviteId");

		if (googleRes.user) {
			let userStr = JSON.stringify(googleRes.user);
			let userObj = JSON.parse(userStr);
			localStorage.setItem('currentUser', userStr);

			var parentData = await this.activityService.getSelfData({ token: userObj.stsTokenManager.accessToken }).toPromise();

			if (!parentData.result) {
				var parts = googleRes.user.displayName.split(" ");
				var affiliateId = await this.generateAffiliateId({ token: userObj.stsTokenManager.accessToken });

				let value = {
					firstName: parts[0],
					lastName: googleRes.user.displayName.replace(parts[0], ""),
					email: googleRes.user.email,
					country: "Undefined",
					childs: [],
					regDate: new Date().getTime(),
					referralId: referral,
					affiliateInfo: { affiliateId: affiliateId ? affiliateId : 0, clicks: 0, registrations: 0, freeMonthsEarned: 0 }
				}

				await this.activityService.createSelfData({ token: userObj.stsTokenManager.accessToken, parent: value }).toPromise();
				sessionStorage.removeItem("inviteId");
				await this.sleep(3000);
			}

			var adminData = await this.activityService.getSelfData({ collectionID: "adminUserData", token: userObj.stsTokenManager.accessToken }).toPromise();

			if (adminData.result) {
				adminData = adminData.result;
				adminData.id = googleRes.user.uid;

				if (adminData['role'] == "super_administrator") {
					localStorage.setItem('superAdmin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('superAdmin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('superAdmin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));

					await this.activityService.setSuperAdminAT({ token: userObj.stsTokenManager.accessToken }).toPromise();

					this.router.navigate(['/admin/super/dashboard']);
				} else {
					localStorage.setItem('quranera_admin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('quranera_admin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('quranera_admin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));
					this.router.navigate(['/admin']);
				}
			} else {
				this.loaderStatus = false;
				this.router.navigate(['/cabinet']);
			}
		} else {
			localStorage.removeItem('currentUser');
			this.loaderStatus = false;
		}
	}

	async loginViaApple() {
		this.loaderStatus = true;
		var googleRes = await this.auth.appleSignin();

		var referral = sessionStorage.getItem("inviteId");

		if (googleRes.user) {
			let userStr = JSON.stringify(googleRes.user);
			let userObj = JSON.parse(userStr);
			localStorage.setItem('currentUser', userStr);

			var parentData = await this.activityService.getSelfData({ token: userObj.stsTokenManager.accessToken }).toPromise();

			if (!parentData.result) {
				var parts = googleRes.user.displayName.split(" ");
				var affiliateId = await this.generateAffiliateId({ token: userObj.stsTokenManager.accessToken });

				let value = {
					firstName: parts[0],
					lastName: googleRes.user.displayName.replace(parts[0], ""),
					email: googleRes.user.email,
					country: "Undefined",
					provider: "Apple.com",
					childs: [],
					regDate: new Date().getTime(),
					referralId: referral,
					affiliateInfo: { affiliateId: affiliateId ? affiliateId : 0, clicks: 0, registrations: 0, freeMonthsEarned: 0 }
				}

				await this.activityService.createSelfData({ token: userObj.stsTokenManager.accessToken, parent: value }).toPromise();
				sessionStorage.removeItem("inviteId");

				await this.sleep(3000);
			}

			var adminData = await this.activityService.getSelfData({ collectionID: "adminUserData", token: userObj.stsTokenManager.accessToken }).toPromise();

			if (adminData.result) {
				adminData = adminData.result;
				adminData.id = googleRes.user.uid;

				if (adminData['role'] == "super_administrator") {
					localStorage.setItem('superAdmin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('superAdmin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('superAdmin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));

					await this.activityService.setSuperAdminAT({ token: userObj.stsTokenManager.accessToken }).toPromise();

					this.router.navigate(['/admin/super/dashboard']);
				} else {
					localStorage.setItem('quranera_admin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('quranera_admin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('quranera_admin_userData', JSON.stringify({
						...adminData,
						uid: adminData.id
					}));
					this.router.navigate(['/admin']);
				}
			} else {
				this.loaderStatus = false;
				this.router.navigate(['/cabinet']);
			}
		} else {
			localStorage.removeItem('currentUser');
			this.loaderStatus = false;
		}
	}

	appendScriptToBody(email: any) {
		if (email) {
			const s = document.createElement("script");
			s.setAttribute('id', 'profitwell-js');
			s.setAttribute('data-pw-auth', 'ddef438d0364d959a508bc1cc2c4d5c1');
			s.setAttribute('type', 'text/javascript');
			s.innerHTML = "(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)}; a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');profitwell('start', { 'user_email': '" + email + "' });";
			document.body.appendChild(s);
		}
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
}
